<template>
  <article v-if="postData" class="block-single-help bg-gray">
    <WpLink
      class="block-help-link"
      :url="postData.link"
      :title="postData.title.rendered.decodeHtmlEntities()"
    >
      <wpImage
        v-if="postData.featured_image_src"
        :data="postData.featured_image_src"
        size="extra_large"
        class="help-image"
        lazy
        background
        placeholder
      />
      <div v-else class="help-image dummy"></div>
      <div class="content-block padding_large">
        <ModuleHeading :level="3">{{ postData.title.rendered.decodeHtmlEntities() }}</ModuleHeading>
        <Categories
          v-if="postData.acf._categories"
          :categories="postData.acf._categories"
          :link="false"
          taxonomy="help_cat"
          :title="false"
        />
        <styledIcon class="icon" v-html="svgIcons.arrow" />
      </div>
    </WpLink>
  </article>

  <div class="block-single-help" v-else>
    <div class="help-image dummy"></div>
    <div class="content-block padding_large">
      <div class="module-header dummy"><span></span><span></span></div>
      <Categories :title="false" />
      <styledIcon class="icon" v-html="svgIcons.arrow" />
    </div>
  </div>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import Categories from "@/components/blocks/CategoriesBlock";
import StyledIcon from "@/components/elements/StyledIcon";
import WpLink from "@/components/elements/WpLink";

import { mapGetters } from "vuex";

export default {
  name: "block-single-help",
  props: { id: Number },
  components: {
    WpImage,
    Categories,
    StyledIcon,
    WpLink
  },
  computed: {
    ...mapGetters(["getPageById"]),
    postData() {
      let post = null;
      if (this.id) {
        post = this.getPageById(this.id);
      }
      return post;
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";

.block-single-help {
  width: 100%;
  transition: box-shadow 0.12s ease-in-out;
  margin-bottom: 25px;
  &:hover {
    box-shadow: 0 0 10px 0 rgba(74, 79, 85, 0.5);
  }
  .block-help-link {
    display: flex;
    width: 100%;
    color: inherit;
    text-decoration: none;
  }
  .categories-block {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
    margin-top: 10px !important;
  }
  .module-header {
    margin-bottom: 10px;
    &.dummy {
      span {
        height: 15px;
        width: 48px;
        display: block;
        margin-bottom: 15px;
        @extend %preloadBgLight;
        &:nth-child(1) {
          width: 80%;
        }
        &:nth-child(2) {
          width: 98%;
        }
      }
    }
  }
  .help-image {
    max-width: 33.5%;
    width: 100%;
    margin: 0;
    @extend %preloadBgLight;
    .wp-image {
      position: relative;
      height: 0;
      padding-bottom: 56.25%;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 50px;
    svg {
      height: 32px;
      width: 32px;
    }
    @include mquery(767px) {
      display: none;
    }
  }
  .content-block {
    position: relative;
    max-width: 66.5%;
    width: 100%;
    align-self: center;
    padding-right: 70px;
    @include mquery(767px) {
      padding-right: 15px;
    }
  }
}
</style>
